import { Box, Typography, Paper } from '@mui/material';
import { colors } from '@src/styles';
import { monoLabelSX, profileCardSX, titleFontFamily, tonePillSX } from '../profileStyles';

export type ProfileHeaderProps = {
  name: string;
  email?: string;
  isAdmin?: boolean;
};

const getInitials = (name: string): string => {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  const first = parts[0][0];
  const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
  return `${first}${last}`.toUpperCase();
};

export const ProfileHeader = ({ name, email, isAdmin }: ProfileHeaderProps) => {
  return (
    <Paper
      elevation={0}
      sx={{
        ...profileCardSX,
        gridColumn: { xs: '1', md: '1 / -1' },
        position: 'relative',
        overflow: 'hidden',
        padding: { xs: '18px 16px', sm: '24px 28px' },
        display: 'flex',
        alignItems: 'center',
        gap: { xs: 2, sm: 2.5 },
        backgroundImage: `radial-gradient(420px 180px at 0% 0%, rgba(255, 160, 21, 0.12), transparent 70%)`,
      }}
    >
      <Box
        aria-hidden
        sx={{
          width: { xs: 52, sm: 64 },
          height: { xs: 52, sm: 64 },
          flexShrink: 0,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: `linear-gradient(140deg, #FFB94A 0%, ${colors.primary.yellow} 100%)`,
          boxShadow: `0 0 0 4px rgba(255, 160, 21, 0.14), 0 10px 30px rgba(255, 160, 21, 0.25)`,
          color: colors.brand.ink,
          fontFamily: titleFontFamily,
          fontSize: { xs: '18px', sm: '22px' },
          fontWeight: 700,
          letterSpacing: '0.02em',
        }}
      >
        {getInitials(name)}
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography sx={{ ...monoLabelSX, marginBottom: 0.5 }}>Seu perfil</Typography>
        <Typography
          component="h1"
          noWrap
          sx={{
            fontFamily: titleFontFamily,
            fontSize: { xs: '20px', sm: '26px' },
            fontWeight: 500,
            letterSpacing: '-0.025em',
            lineHeight: 1.15,
            color: colors.primary.white,
          }}
        >
          {name}
        </Typography>
        <Typography noWrap sx={{ marginTop: 0.5, fontSize: '13.5px', color: colors.brand.textSecondary }}>
          {email || '-'}
        </Typography>
      </Box>
      {isAdmin && <Box sx={{ ...tonePillSX(colors.primary.yellow), alignSelf: 'flex-start' }}>Admin</Box>}
    </Paper>
  );
};
